// extracted by mini-css-extract-plugin
var _1 = "Buttons-module__buttons--r0nB1";
export { _1 as "buttons" }
